'use client';

import { useEffect, useRef } from 'react';
import type { ReactNode, RefObject } from 'react';
import Link from 'next/link';
import './partnership.css';

/* Saari styling partnership.css mein hai (scope: .pe-page).
   Images: sirf wahi jo tumhari file mein thi (Unsplash URLs, kuch change nahi):
   - Hero background      -> CSS ".partnership-hero-bg-image"  (photo-1486406146926)
   - Final CTA background -> CSS ".final-cta-bg"    (photo-1464822759023)
   - 3 tech card images   -> neeche `techCards` array (image field)

   Links: "Explore Axentia" -> AXENTIA_URL (external site, neeche constant me badlo). */

/* TODO: confirm karo ki Axentia ka sahi website yahi hai */
const AXENTIA_URL = 'https://axentiaai.in';

type IconName =
  | 'cube' | 'people' | 'plug' | 'basket' | 'truck' | 'chart' | 'layers' | 'shield'
  | 'cloud' | 'chip' | 'globe' | 'database' | 'code' | 'branch' | 'atom' | 'server'
  | 'spark' | 'bulb' | 'target' | 'network' | 'gear';

function Icon({ name }: { name: IconName }) {
  const paths: Record<IconName, ReactNode> = {
    cube: <><path d="M12 3 4 7.5v9L12 21l8-4.5v-9z" /><path d="M4 7.5 12 12l8-4.5M12 12v9" /></>,
    people: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><path d="M16 5a3 3 0 0 1 0 6M18 14c1.8.8 3 2.6 3 5" /></>,
    plug: <><path d="M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0zM12 17v4" /></>,
    basket: <><path d="M3 9h18l-2 11H5z" /><path d="m8 9 3-5M16 9l-3-5" /></>,
    truck: <><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z" /><circle cx="7" cy="18" r="2" /><circle cx="18" cy="18" r="2" /></>,
    chart: <><path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6" /></>,
    layers: <><path d="M12 3 3 8l9 5 9-5z" /><path d="m3 12 9 5 9-5" /><path d="m3 16 9 5 9-5" /></>,
    shield: <><path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6z" /><path d="m9 12 2 2 4-4" /></>,
    cloud: <><path d="M7 18a4 4 0 0 1-.5-8 5.5 5.5 0 0 1 10.7 1.3A3.5 3.5 0 0 1 17 18z" /></>,
    chip: <><rect x="7" y="7" width="10" height="10" rx="2" /><path d="M9 3v4M15 3v4M9 17v4M15 17v4M3 9h4M3 15h4M17 9h4M17 15h4" /></>,
    globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></>,
    database: <><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></>,
    code: <><path d="m8 8-5 4 5 4M16 8l5 4-5 4M14 5l-4 14" /></>,
    branch: <><circle cx="6" cy="6" r="2" /><circle cx="6" cy="18" r="2" /><circle cx="18" cy="8" r="2" /><path d="M6 8v8M18 10c0 4-6 3-12 6" /></>,
    atom: <><circle cx="12" cy="12" r="1.5" /><ellipse cx="12" cy="12" rx="9" ry="3.5" /><ellipse cx="12" cy="12" rx="9" ry="3.5" transform="rotate(60 12 12)" /><ellipse cx="12" cy="12" rx="9" ry="3.5" transform="rotate(120 12 12)" /></>,
    server: <><rect x="3" y="4" width="18" height="6" rx="1.5" /><rect x="3" y="14" width="18" height="6" rx="1.5" /><path d="M7 7h.01M7 17h.01" /></>,
    spark: <><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" /></>,
    bulb: <><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.6.6 1 1.4 1 2.5h6c0-1.1.4-1.9 1-2.5A6 6 0 0 0 12 3z" /></>,
    target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></>,
    network: <><circle cx="12" cy="5" r="2.5" /><circle cx="5" cy="19" r="2.5" /><circle cx="19" cy="19" r="2.5" /><path d="M12 7.5v4M12 11.5l-6 5.5M12 11.5l6 5.5" /></>,
    gear: <><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" /></>,
  };

  return (
    <svg className="pe-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
}

function Arrow() {
  return (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M14 5l7 7m0 0l-7 7m7-7H3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

/* ============================== DATA ============================== */

const benefits: { icon: IconName; title: string }[] = [
  { icon: 'people', title: 'Global Technology Partners' },
  { icon: 'network', title: 'Strategic Ecosystem Collaborations' },
  { icon: 'globe', title: 'Industry Networks and Alliances' },
  { icon: 'code', title: 'Open Source and Community Engagement' },
  { icon: 'bulb', title: 'Joint Innovation with Axentia' },
  { icon: 'target', title: 'Built Around Real Business Problems' },
];

type TechItem = { icon: IconName; title: string; sub: string };

const sapItems: TechItem[] = [
  { icon: 'cube', title: 'S/4HANA', sub: '(RISE | GROW)' },
  { icon: 'people', title: 'SuccessFactors', sub: '(HXM)' },
  { icon: 'plug', title: 'BTP', sub: '(Innovation & Integration)' },
  { icon: 'basket', title: 'Ariba', sub: '(Procurement)' },
  { icon: 'truck', title: 'EWM / EAM', sub: '(Supply Chain & Assets)' },
  { icon: 'chart', title: 'SAC', sub: '(Planning & Analytics)' },
];

const awsItems: TechItem[] = [
  { icon: 'layers', title: 'Scalable', sub: 'Infrastructure' },
  { icon: 'shield', title: 'Security', sub: '& Compliance' },
  { icon: 'chart', title: 'Data & Analytics', sub: 'Services' },
  { icon: 'chip', title: 'AI / ML', sub: 'Services' },
  { icon: 'cloud', title: 'Hybrid & Multi-cloud', sub: 'Architecture' },
  { icon: 'globe', title: 'Global', sub: 'Reach' },
];

const openItems: TechItem[] = [
  { icon: 'database', title: 'PostgreSQL', sub: '+ pgvector' },
  { icon: 'code', title: 'Python', sub: 'data science' },
  { icon: 'branch', title: 'Open Source', sub: 'Open LLMs & AI' },
  { icon: 'atom', title: 'React', sub: 'front-end' },
  { icon: 'server', title: 'Node.js', sub: 'applications' },
  { icon: 'spark', title: 'XGBoost', sub: '+ ML' },
];

const techCards: {
  key: string; name: string; brand: string; headline: string; text: string; image: string; items: TechItem[];
}[] = [
  {
    key: 'sap', name: 'SAP', brand: 'SAP', headline: 'Enterprise Applications',
    text: 'Deep SAP capability across industries and solutions to help enterprises transform, operate and grow.',
    image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1000&q=85',
    items: sapItems,
  },
  {
    key: 'aws', name: 'AWS', brand: 'aws', headline: 'Cloud and Data',
    text: 'Cloud infrastructure and services to build, modernise and scale enterprise applications and AI solutions.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1000&q=85',
    items: awsItems,
  },
  {
    key: 'open', name: 'Open Source', brand: 'OSS', headline: 'Open Source and Community',
    text: 'An open and sovereign technology stack to build enterprise data, AI and application solutions — flexible, secure and independent.',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1000&q=85',
    items: openItems,
  },
];

const strategicPartners = ['Microsoft', 'Google Cloud', 'databricks', 'Snowflake', 'Anthropic', 'NVIDIA', 'Legality', 'UiPath', 'Others'];

const oraneStrengths = [
  'Industry Knowledge and Experience',
  'Business Processes and Consulting',
  'Delivery and Operations',
  'Global Talent and Scale',
];
const axentiaStrengths = [
  'AI and Emerging Technologies',
  'Capability Development',
  'Experimentation and Prototypes',
  'New Talent Models',
];

const orgPoints: { icon: IconName; text: string }[] = [
  { icon: 'layers', text: 'Orane brings deep enterprise and industry experience, business processes and large-scale delivery capabilities.' },
  { icon: 'network', text: 'Together, we explore and build new ways to solve enterprise problems through AI, data and capability.' },
  { icon: 'bulb', text: 'Axentia brings AI-native capability, applied AI, experimentation and new talent models.' },
];

const finalValues = ['MORE KNOWLEDGE', 'MORE CAPABILITY', 'MORE OPPORTUNITY', 'MORE VALUE', 'TOGETHER'];

/* ===================== SCROLL ANIMATION ===================== */
/* Sirf fade-up (neeche se upar) aur zoom. Left/right slide nahi. */
const animGroups: [string, 'fade-up' | 'zoom'][] = [
  ['.sec-head', 'fade-up'],
  ['.benefit-grid .eco-card', 'zoom'],
  ['.tech-card', 'fade-up'],
  ['.ps-card', 'fade-up'],
  ['.eco-side, .eco-core', 'zoom'],
  ['.lead-card', 'zoom'],
  ['.lead-foot', 'fade-up'],
  ['.final-cta-box', 'zoom'],
  ['.final-cta-value', 'fade-up'],
];

function useScrollReveal(root: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = root.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('rv--in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    animGroups.forEach(([selector, type]) => {
      const perParent = new Map<Element, number>();
      el.querySelectorAll<HTMLElement>(selector).forEach((node) => {
        const parent = node.parentElement as Element;
        const i = perParent.get(parent) ?? 0;
        perParent.set(parent, i + 1);

        node.classList.add('rv', `rv--${type}`);
        node.style.setProperty('--rv-delay', `${(i % 6) * 80}ms`); // stagger
        io.observe(node);
      });
    });

    return () => io.disconnect();
  }, [root]);
}

/* ============================== PAGE ============================== */

export default function PartnershipEcosystem() {
  const pageRef = useRef<HTMLDivElement>(null);
  useScrollReveal(pageRef);

  return (
    <div className="pe-page" ref={pageRef}>
      <main>
        {/* ============================= HERO ============================= */}
        <section className="partnership-hero" data-purpose="hero-section" id="about">
          <div className="partnership-hero-bg-image"></div>
          <div className="partnership-hero-bg-overlay"></div>
          <div className="partnership-hero-grid"></div>
          <div className="partnership-hero-glow partnership-hero-glow--left"></div>
          <div className="partnership-hero-glow partnership-hero-glow--right"></div>

          <div className="op-container op-container--left partnership-hero-inner">
            <div className="partnership-hero-layout">
              <div className="partnership-hero-content">
                <h1 className="partnership-hero-title">
                  Better Outcomes
                  <span className="partnership-hero-title-accent">Are Built Together.</span>
                </h1>

                <p className="partnership-hero-text">
                  We work with global technology partners, open source communities, industry networks and
                  Axentia to bring the right capabilities to our customers and create lasting enterprise
                  value.
                </p>

                <div className="partnership-hero-actions">
                  <Link className="btn-primary" href="#ecosystem">
                    Our Ecosystem
                    <Arrow />
                  </Link>
                  <Link className="btn-glass" href="#journey">
                    See How We Work Together
                    <span className="play-icon">▶</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============================ BENEFITS ============================ */}
        <section className="op-section op-section--white" data-purpose="benefits">
          <div className="op-container">
            <div className="benefit-grid">
              {benefits.map((b) => (
                <div className="eco-card" key={b.title}>
                  <div className="eco-icon">
                    <Icon name={b.icon} />
                  </div>
                  <h3 className="eco-title">{b.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===================== CORE TECHNOLOGY PARTNERS ===================== */}
        <section className="op-section op-section--slate" data-purpose="core-partners" id="ecosystem">
          <div className="op-container">
            <div className="sec-head">
              <div className="sec-badge">Technology Partners</div>
              <h2 className="sec-title">Our Core Technology Partners</h2>
              <p className="sec-sub">
                World-class technology platforms that enable enterprise transformation and intelligence.
              </p>
            </div>

            <div className="tech-grid">
              {techCards.map((card) => (
                <article className="tech-card" key={card.key}>
                  <div className="tech-media">
                    <img src={card.image} alt="" loading="lazy" />
                    <span className="tech-brand">{card.brand}</span>
                    <span className="tech-label">{card.headline}</span>
                  </div>
                  <div className="tech-body">
                    <h3 className="tech-headline">{card.headline}</h3>
                    <p className="tech-text">{card.text}</p>
                    <div className="tech-items">
                      {card.items.map((item) => (
                        <div className="tech-item" key={item.title}>
                          <span className="tech-item-icon">
                            <Icon name={item.icon} />
                          </span>
                          <strong className="tech-item-title">{item.title}</strong>
                          <small className="tech-item-sub">{item.sub}</small>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
            </div>

            <div className="ps-card">
              <h3 className="ps-title">Other Strategic Partners</h3>
              <p className="ps-sub">Industry solutions and complementary capabilities.</p>
              <div className="sys-grid">
                {strategicPartners.map((name) => (
                  <span className="sys-chip" key={name}>{name}</span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ======================== OUR ECOSYSTEM APPROACH ======================== */}
        <section className="op-section op-section--white" data-purpose="ecosystem-approach" id="journey">
          <div className="op-container">
            <div className="sec-head sec-head--center">
              <div className="sec-badge">Ecosystem</div>
              <h2 className="sec-title">Our Ecosystem Approach</h2>
              <p className="sec-sub sec-sub--base">
                Combining the right capabilities to solve real enterprise problems.
              </p>
            </div>

            <div className="eco-diagram">
              <div className="eco-side">
                <div className="eco-side-head">
                  <b>Orane</b>
                  <span>Enterprise Experience · Transformation Delivery</span>
                </div>
                {oraneStrengths.map((x) => (
                  <div className="eco-pill" key={x}>
                    <span className="eco-pill-icon">
                      <Icon name="gear" />
                    </span>
                    {x}
                  </div>
                ))}
              </div>

              <span className="eco-link">⇄</span>

              <div className="eco-core">
                <span className="eco-core-icon">
                  <Icon name="people" />
                </span>
                <b>CUSTOMERS</b>
                <span>Real Business Problems and Outcomes</span>
              </div>

              <span className="eco-link">⇄</span>

              <div className="eco-side eco-side--axentia">
                <div className="eco-side-head">
                  <b>Axentia</b>
                  <span>AI-Native Innovation · Capability Building</span>
                </div>
                {axentiaStrengths.map((x) => (
                  <div className="eco-pill" key={x}>
                    <span className="eco-pill-icon">
                      <Icon name="bulb" />
                    </span>
                    {x}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ========================== ORANE × AXENTIA ========================== */}
        <section className="op-section op-section--slate" data-purpose="orane-axentia">
          <div className="op-container">
            <div className="sec-head">
              <div className="sec-badge">Better Together</div>
              <h2 className="sec-title">Orane × Axentia</h2>
              <p className="sec-sub">Enterprise experience meets AI-native innovation.</p>
            </div>

            <div className="lead-grid">
              {orgPoints.map((p) => (
                <div className="lead-card" key={p.text}>
                  <span className="lead-icon">
                    <Icon name={p.icon} />
                  </span>
                  <p className="lead-text">{p.text}</p>
                </div>
              ))}
            </div>

            <div className="lead-foot">
              {/* Bahari (external) site hai, isliye <Link> ki jagah normal <a> + naye tab me khulta hai */}
              <a className="btn-small" href={AXENTIA_URL} target="_blank" rel="noopener noreferrer">
                Explore Axentia
                <Arrow />
              </a>
            </div>
          </div>
        </section>

        {/* ========================= FINAL CTA ================================ */}
        <section className="final-cta" data-purpose="final-call-to-action" id="contact">
          <div className="final-cta-bg"></div>
          <div className="final-cta-overlay"></div>
          <div className="op-container final-cta-inner">
            <div className="final-cta-box">
              <div className="final-cta-left">
                <span className="final-cta-eyebrow">DIFFERENT PARTNERS. COMPLEMENTARY STRENGTHS.</span>
                <h2 className="final-cta-title">Do More. Together.</h2>
                <p className="final-cta-text">A shared purpose — real progress for our customers.</p>
              </div>
              <div className="final-cta-right">
                <Link className="btn-primary btn-primary--cta" href="/tellusyourproblem#tell-details">
                  Talk to Our Team
                  <Arrow />
                </Link>
                {/* TODO: brochure ki PDF ya page aane par yahan href badlo (abhi same page ke ecosystem section par scroll karta hai) */}
                <Link className="btn-glass btn-glass--cta" href="#ecosystem">
                  Our Ecosystem Brochure
                  <Arrow />
                </Link>
              </div>
            </div>

            <div className="final-cta-values">
              {finalValues.map((v) => (
                <span className="final-cta-value" key={v}>{v}</span>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}